import { IconButton, type SxProps, type Theme } from '@mui/material';
import { ChevronDown, X } from 'lucide-react';

const sx: SxProps<Theme> = {
  p: '3px',
  color: 'error.main',
  transition: 'all 0.15s ease',
  '&:hover': {
    bgcolor: 'error.main',
    color: '#fff',
    '& svg': { color: '#fff' },
  },
};

export const DeleteButton = ({ onClick }: { onClick: () => void }) => (
  <IconButton size="small" onClick={onClick} sx={sx}>
    <X size={14} />
  </IconButton>
);

export const autocompletePopupIcon = <ChevronDown size={14} />;
export const autocompleteClearIcon = <X size={14} />;

export const autocompleteSx: SxProps<Theme> = {
  '& .MuiInputBase-root': {
    py: '0px !important',
  },
  '& .MuiInputBase-input': {
    py: '3px !important',
  },
};
